export default "__VITE_ASSET__38f5798a__"